// ── useClearStats — очистить статистику с «Отменить» ─────────────────────────
// Статистика стирается на устройстве сразу (снимок сохраняется), а на сервере —
// только через 6 секунд, когда закроется «Отменить»: отмена возвращает всё без
// сети. Новая очистка, пока ждёт прежняя, сначала отправляет прежнюю на сервер.
// Закрыли вкладку во время ожидания — отправляем сразу, чтобы устройство и
// сервер не разошлись.
//   const stats = useClearStats(session);
//   stats.clear("ja" | "__none__" (записи без языка) | "__all__");
//   {stats.pending && <UndoToast label={stats.pending.label} onUndo={stats.undo} />}

import { useCallback, useEffect, useState } from 'react';
import { t } from '../i18n';
import { clearLangStatsRemote } from '../storage';
import { clearLangStats, getAllStatsBuckets, restoreLangStats } from '../utils';

export const UNDO_MS = 6000;

export default function useClearStats(session) {
  const [pending, setPending] = useState(null);
  const uid = session?.user?.id;

  const clear = useCallback((target) => {
    if (!target) return;
    const commitRemote = (langs) => { if (uid) langs.forEach((l) => clearLangStatsRemote(uid, l).catch(() => {})); };
    if (pending) {
      clearTimeout(pending.timer);
      commitRemote(pending.langs);
      setPending(null);
    }
    const langs = target === '__all__' ? getAllStatsBuckets() : target === '__none__' ? [''] : [target];
    const snaps = langs.map((l) => clearLangStats(l));
    const label = target === '__all__' ? t("Вся статистика очищена")
      : target === '__none__' ? t("Записи без языка очищены")
      : t("Статистика «{0}» очищена", [target.toUpperCase()]);
    const timer = setTimeout(() => { commitRemote(langs); setPending(null); }, UNDO_MS);
    setPending({ langs, snaps, label, timer });
  }, [pending, uid]);

  const undo = useCallback(() => {
    if (!pending) return;
    clearTimeout(pending.timer);
    pending.langs.forEach((l, i) => restoreLangStats(l, pending.snaps[i]));
    setPending(null);
  }, [pending]);

  useEffect(() => {
    if (!pending) return undefined;
    const commit = () => { if (uid) pending.langs.forEach((l) => clearLangStatsRemote(uid, l).catch(() => {})); };
    window.addEventListener('beforeunload', commit);
    return () => window.removeEventListener('beforeunload', commit);
  }, [pending, uid]);

  return { pending, clear, undo };
}
